<template>
  <div class="product-display">
    <!-- 顶部筛选区域 -->
    <el-row class="filter-bar" justify="center" v-if="!showDetail">
      <el-col :span="20">
        <div class="filter-container">
          <!-- 分类标签 -->
          <div class="categories">
            <el-button
              v-for="category in categories"
              :key="category"
              type="text"
              :class="{ active: selectedCategory === category }"
              @click="filterByCategory(category)"
            >
              {{ category }}
            </el-button>
          </div>

          <!-- 子分类和搜索（融合在一个框中） -->
          <div class="search-tools">
            <el-input
              v-model="searchQuery"
              placeholder="搜索..."
              class="search-input-group"
            >
              <template #prepend>
                <el-select
                  v-model="selectedSubCategory"
                  placeholder="子分类"
                  style="width: 80px"
                >
                  <el-option
                    v-for="subCategory in subCategories"
                    :key="subCategory"
                    :label="subCategory"
                    :value="subCategory"
                  />
                </el-select>
              </template>
            </el-input>
          </div>
        </div>
      </el-col>
    </el-row>

    <!-- 产品展示区域 -->
    <el-row :gutter="20" class="product-grid" v-if="!showDetail">
      <el-col
        v-for="product in filteredProducts"
        :key="product.title"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
      >
        <el-card shadow="hover" class="product-card">
          <div
            class="product-image"
            :style="{ backgroundImage: `url(${product.image})` }"
          />
          <div class="product-info">
            <span>{{ product.category }} | {{ product.title }}</span>
          </div>
          <div class="overlay" @click="openDetail(product)"></div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 替换后的二级页面 -->
    <div v-if="showDetail" class="detail-page">
      <div class="detail-header">
        <h2>{{ selectedProduct.title }}</h2>
        <el-button @click="closeDetail">返回</el-button>
      </div>
      <div class="content-section">
        <!-- 左侧视图选择 -->
        <div class="preview-section">
          <!-- <button class="arrow left" @click="prevImage">←</button> -->
          <div class="thumbnail-container">
            <div
              class="thumbnail"
              v-for="(image, index) in selectedProduct.images"
              :key="index"
              :style="{ backgroundImage: `url(${image})` }"
              @click="updateMainImage(image)"
              :class="{ active: selectedProduct.mainImage === image }"
            />
          </div>
          <!-- <button class="arrow right" @click="nextImage">→</button> -->
          <div class="main-image" :style="{ backgroundImage: `url(${selectedProduct.mainImage})` }" />
        </div>
        <!-- 右侧加工参数 -->
        <div class="parameter-section">
          <h3>建议加工参数</h3>
          <div class="parameter-info">
            <p>宽度: {{ selectedProduct.width }}</p>
            <p>高度: {{ selectedProduct.height }}</p>
            <p>功率: {{ selectedProduct.power }}</p>
            <p>速度: {{ selectedProduct.speed }}</p>
            <p>类型: {{ selectedProduct.type }}</p>
          </div>
          <el-button type="primary" @click="handleDownload(selectedProduct.downloadUrl)">下载</el-button>
          <el-button type="success" @click="handleMake">制作</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      categories: [
        "全部分类",
        "工艺品",
        "节日装饰",
        "家具用品",
        "动物植物",
        "交通工具",
        "建筑结构",
        "人像雕刻"
      ],
      selectedCategory: "全部分类",
      subCategories: ["图纸", "图片"],
      selectedSubCategory: "图纸",
      searchQuery: "",
      products: [],
      showDetail: false,
      selectedProduct: null
    };
  },

  created() {
    // 组件创建时获取数据
    this.fetchPhotoData();
  },

  methods: {
    // 获取图库数据
    fetchPhotoData() {
      axios.get('/api/photo/selectAll')
        .then(response => {
          if (response.data.success) {
            // 处理返回的数据
            this.products = response.data.data.map(item => ({
              id: item.id,
              image: `/resources/photo/${item.image}`, // 添加图片路径前缀
              category: item.category,
              subCategory: item.subCategory,
              title: item.title,
              width: item.width,
              height: item.height,
              power: item.power,
              speed: item.speed,
              type: item.type,
              // 处理图片列表
              images: item.imagesList.map(img => `/resources/photo/${img}`),
              mainImage: `/resources/photo/${item.mainImage}`,
              downloadUrl: `/resources/photo/${item.downloadUrl}`
            }));
          } else {
            this.$message.error('获取图库数据失败');
          }
        })
        .catch(error => {
          console.error('获取图库数据失败:', error);
          this.$message.error('获取图库数据失败');
        });
    },

    filterByCategory(category) {
      this.selectedCategory = category;
    },

    openDetail(product) {
      this.selectedProduct = product;
      this.showDetail = true;
    },

    closeDetail() {
      this.showDetail = false;
      this.selectedProduct = null;
    },

    updateMainImage(image) {
      this.selectedProduct.mainImage = image;
    },

    // 下载处理
    handleDownload(url) {
      window.open(url, '_blank');
    },

    // 制作按钮处理
    handleMake() {
      // 处理制作逻辑
      console.log('制作按钮点击');
    }
  },

  computed: {
    filteredProducts() {
      return this.products.filter((product) => {
        const categoryMatch =
          this.selectedCategory === "全部分类" ||
          product.category === this.selectedCategory;
        const subCategoryMatch = this.selectedSubCategory === product.subCategory;
        const searchMatch = product.title.toLowerCase().includes(this.searchQuery.toLowerCase());
        return categoryMatch && subCategoryMatch && searchMatch;
      });
    },
  }
};
</script>

<style scoped>
.product-display {
  padding: 20px;
}
.filter-bar {
  width: 100%;
  margin-bottom: 20px;
}
.filter-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  border-radius: 8px;
  width: 100%;
  margin-left: 8%;
}
.categories {
  flex: 1;
  display: flex;
  justify-content: space-between;
  margin-right: 20px;
}
.categories .el-button {
  margin: 0 5px;
  color: #333;
}
.categories .el-button.active {
  color: #409eff;
  border-bottom: 2px solid #409eff;
}
.search-tools {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
.search-input-group {
  width: 100%;
}
.product-grid {
  max-height: 600px;
  overflow-y: auto;
}
.product-card {
  position: relative;
  cursor: pointer;
  text-align: center;
  padding: 0 !important;
}
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0); /* 透明背景 */
}
.product-image {
  width: 100%;
  padding-top: 75%;
  background-size: cover;
  background-position: center;
  transition: transform 0.3s;
}
.product-card:hover .product-image {
  transform: scale(1.1);
}
.product-info {
  margin-top: 10px;
  font-size: 14px;
  color: #666;
}
/* 二级页面样式 */
.detail-page {
  display: flex;
  padding: 20px;
  flex-direction: column;

}
.content-section {
  display: flex;
}
.preview-section {
  flex: 1;
  display: flex;
  align-items: center;
}
.arrow {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 24px;
}
.thumbnail-container {
  display: flex;
	flex-direction: column;
}
.thumbnail {
  width: 100px;
  height: 100px;
  margin-right: 50px;
  background-size: cover;
  background-position: center;
	margin-top: 10px;
  cursor: pointer;
}
.thumbnail.active {
  border: 2px solid #409eff; /* 选择状态样式 */
}
.main-image {
  width: 100%;
  height: 400px;
  background-size: cover;
  background-position: center;
  margin-top: 20px;
}
.parameter-section {
  flex: 1;
  background-color: #f5f5f5; /* 浅灰色背景 */
  padding: 15px;
  border-radius: 8px;
	margin-left: 50px;
}
.parameter-info {
  margin-bottom: 10px;
}
.parameter-info p{
  margin-top: 20px;
  margin-bottom: 50px;
}
</style>
